var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuara1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_845_38405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 64
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5176,
    cy: 32,
    r: 32,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_845_38405)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5176,
    cy: 32,
    r: 32,
    fill: "#00BCF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4229 48.4057L22.3763 48.4657C22.1053 48.7775 21.7743 49.0314 21.4029 49.2124C21.0872 49.3575 20.7438 49.4326 20.3963 49.4324C20.2238 49.4313 20.0519 49.4134 19.8829 49.3791L21.0629 47.3324C21.4551 46.7847 21.7187 46.1556 21.8342 45.4919C21.9496 44.8282 21.9138 44.147 21.7296 43.4991C21.4363 42.6591 20.9096 42.5591 20.7363 42.5257H20.6629C17.3992 41.6308 14.3901 39.9847 11.8763 37.7191C11.4829 37.3657 11.1029 37.0057 10.7363 36.6257C10.3696 36.2457 9.95628 35.7391 9.58294 35.2924C8.73775 34.2788 7.9774 33.1974 7.30961 32.0591C5.38151 28.7703 4.22575 25.0865 3.92961 21.2857L3.84961 20.3391L4.31628 20.0391L14.1829 20.3391L14.1429 21.2524C14.1429 21.2524 14.0629 23.7457 15.4763 25.2524C15.8024 25.6043 16.1972 25.8856 16.6363 26.0791C17.2446 26.3427 17.8999 26.481 18.5629 26.4857L19.0296 28.3924C18.2293 28.3432 17.4362 28.2114 16.6629 27.9991C15.7278 27.7237 14.8831 27.2035 14.2163 26.4924C13.1639 25.2659 12.5371 23.7316 12.4296 22.1191H5.76294C6.01325 24.1782 6.53327 26.1955 7.30961 28.1191C7.91408 29.6178 8.67614 31.0481 9.58294 32.3857C9.94961 32.9324 10.3429 33.4524 10.7496 33.9524C11.1563 34.4524 11.4896 34.8324 11.8896 35.2457C14.3999 37.8957 17.5852 39.8111 21.1029 40.7857C21.2478 40.8155 21.3904 40.8556 21.5296 40.9057C21.9743 41.0719 22.3744 41.339 22.6983 41.686C23.0222 42.0331 23.2612 42.4506 23.3963 42.9057C23.6751 43.8348 23.7323 44.8163 23.5633 45.7714C23.3942 46.7266 23.0037 47.6288 22.4229 48.4057Z",
    fill: "url(#paint0_linear_845_38405)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1834 21.5205L12.4301 22.0939H5.92339L5.63672 21.0605L13.1834 21.5205Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4228 48.4062L22.3761 48.4663C22.1052 48.778 21.7741 49.032 21.4028 49.2129C21.0871 49.3581 20.7436 49.4331 20.3961 49.4329C20.2237 49.4318 20.0518 49.4139 19.8828 49.3796L20.3495 49.0796L22.4228 48.4062Z",
    fill: "#808080"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8431 48.1657C22.5647 48.4763 22.227 48.7279 21.8497 48.9057C21.5345 49.053 21.191 49.1303 20.8431 49.1324C20.6706 49.1313 20.4987 49.1134 20.3297 49.0791L21.5097 47.0057C21.9002 46.4572 22.1627 45.8281 22.2781 45.1647C22.3934 44.5013 22.3587 43.8206 22.1764 43.1724C21.8831 42.3324 21.3564 42.2324 21.1764 42.1991H21.1097C17.846 41.3041 14.8369 39.6581 12.3231 37.3924C11.9297 37.0391 11.5497 36.6724 11.1831 36.2991C10.8164 35.9257 10.4231 35.4391 10.0497 34.9924C9.20454 33.9788 8.4442 32.8974 7.77641 31.7591C5.84916 28.4695 4.69136 24.7864 4.38974 20.9857L4.31641 20.0391H14.6497L14.6097 20.9524C14.6097 20.9524 14.5297 23.4457 15.9431 24.9524C16.2668 25.3041 16.6594 25.5855 17.0964 25.7791C17.7071 26.0427 18.3646 26.181 19.0297 26.1857L18.9897 27.9324C18.3491 27.9222 17.7126 27.828 17.0964 27.6524C16.1624 27.3753 15.3197 26.8527 14.6564 26.1391C13.6028 24.9133 12.9758 23.3786 12.8697 21.7657H6.20307C6.45308 23.8249 6.9731 25.8423 7.74974 27.7657C8.36067 29.2834 9.1317 30.7316 10.0497 32.0857C10.4164 32.6257 10.8097 33.1524 11.2164 33.6524C11.6231 34.1524 11.9564 34.5324 12.3564 34.9391C14.8649 37.5894 18.0476 39.5069 21.5631 40.4857C21.7089 40.5115 21.8518 40.5517 21.9897 40.6057C22.4365 40.7696 22.8386 41.0359 23.164 41.3832C23.4893 41.7305 23.7287 42.1492 23.8631 42.6057C24.1448 43.5471 24.1993 44.5419 24.022 45.5084C23.8447 46.475 23.4406 47.3857 22.8431 48.1657Z",
    fill: "url(#paint1_linear_845_38405)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8429 48.1674C22.5646 48.478 22.2268 48.7296 21.8496 48.9074C23.6496 45.6808 22.6696 42.2408 21.9696 40.6074C22.4164 40.7713 22.8185 41.0376 23.1438 41.3849C23.4691 41.7322 23.7086 42.1509 23.8429 42.6074C24.1275 43.5473 24.1852 44.5412 24.0114 45.5076C23.8375 46.4741 23.4371 47.3856 22.8429 48.1674Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.123 25.8008C17.7338 26.0644 18.3912 26.2027 19.0564 26.2074L19.0164 27.9541C18.3757 27.9439 17.7392 27.8498 17.123 27.6741V25.8008Z",
    fill: "#808080"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9768 20.3409L60.9035 21.2876C60.6322 24.6979 59.6729 28.018 58.0835 31.0476C57.7702 31.6409 57.4168 32.2076 57.0902 32.7676C56.7635 33.3276 56.3702 33.8476 55.9835 34.3676C55.354 35.1965 54.6726 35.9847 53.9435 36.7276C51.2464 39.4804 47.8669 41.4681 44.1502 42.4876H44.0835C43.8407 42.5344 43.617 42.6517 43.4404 42.8248C43.2637 42.9978 43.142 43.2191 43.0902 43.4609C42.7808 44.5733 42.8948 45.761 43.4102 46.7942C43.5099 46.9791 43.6283 47.1534 43.7635 47.3142L45.6368 49.0876L44.9702 49.3876C44.8012 49.4219 44.6293 49.4397 44.4568 49.4409C44.1904 49.4517 43.9241 49.4156 43.6702 49.3342C43.4178 49.2446 43.1797 49.1189 42.9635 48.9609C42.7781 48.8218 42.6063 48.6655 42.4502 48.4942C41.853 47.7126 41.4493 46.8008 41.272 45.8333C41.0947 44.8658 41.1489 43.8701 41.4302 42.9276C41.571 42.449 41.8269 42.0122 42.1756 41.6554C42.5242 41.2986 42.955 41.0327 43.4302 40.8809L43.7035 40.8142C47.7123 39.6946 51.2786 37.3667 53.9168 34.1476C54.6702 33.2347 55.3522 32.2651 55.9568 31.2476C56.3612 30.5646 56.7306 29.8614 57.0635 29.1409C57.4399 28.3081 57.7715 27.4558 58.0568 26.5876C58.5243 25.1308 58.8525 23.633 59.0368 22.1142H52.3702C52.2627 23.7267 51.6359 25.2611 50.5835 26.4876C49.915 27.2047 49.065 27.7276 48.1235 28.0009C47.5229 28.174 46.9018 28.2659 46.2768 28.2742L46.2368 26.5276C46.8848 26.5221 47.5256 26.3908 48.1235 26.1409C48.5826 25.9434 48.9958 25.6528 49.3368 25.2876C50.7502 23.7742 50.6702 21.2876 50.6702 21.2876L50.6302 20.3742L51.2968 20.0742L60.9768 20.3409Z",
    fill: "url(#paint2_linear_845_38405)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8834 21.6939L59.0634 22.0939H52.4434V21.2539L59.8834 21.6939Z",
    fill: "#808080"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6684 20.0391L61.5884 20.9857C61.3192 24.3965 60.3598 27.717 58.7684 30.7457C58.455 31.3391 58.1017 31.9057 57.775 32.4657C57.4484 33.0257 57.055 33.5457 56.6684 34.0657C56.0408 34.8962 55.3593 35.6846 54.6284 36.4257C51.9337 39.1784 48.5564 41.1661 44.8417 42.1857H44.7684C44.595 42.2191 44.0684 42.3191 43.775 43.1591C43.4677 44.2723 43.5841 45.46 44.1017 46.4924C44.1975 46.6817 44.3162 46.8586 44.455 47.0191L45.635 49.0924C45.466 49.1263 45.2941 49.1441 45.1217 49.1457C44.8609 49.1465 44.6017 49.1037 44.355 49.0191C44.1017 48.9288 43.8634 48.8006 43.6484 48.6391C43.4623 48.5058 43.2922 48.3515 43.1417 48.1791C42.5431 47.3982 42.1385 46.4864 41.9611 45.5186C41.7838 44.5508 41.8388 43.5548 42.1217 42.6124C42.2604 42.1328 42.5156 41.6949 42.8645 41.3378C43.2135 40.9807 43.6454 40.7154 44.1217 40.5657C44.2087 40.5365 44.2979 40.5142 44.3884 40.4991C48.3975 39.3803 51.964 37.0522 54.6017 33.8324C55.3572 32.9235 56.0394 31.956 56.6417 30.9391C57.05 30.256 57.4195 29.5504 57.7484 28.8257C58.1316 27.9981 58.4633 27.1476 58.7417 26.2791C59.2162 24.8219 59.5445 23.3212 59.7217 21.7991H53.055C52.9457 23.4111 52.3191 24.9449 51.2684 26.1724C50.5911 26.8966 49.729 27.4221 48.775 27.6924C48.1766 27.865 47.5578 27.9569 46.935 27.9657L46.895 26.2191C47.5408 26.213 48.1793 26.0816 48.775 25.8324C49.2351 25.6367 49.6486 25.3459 49.9884 24.9791C51.4084 23.4657 51.3217 20.9791 51.3217 20.9791L51.2817 20.0657L61.6684 20.0391Z",
    fill: "url(#paint3_linear_845_38405)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6484 48.6261C43.4623 48.4928 43.2922 48.3385 43.1417 48.1661C42.5431 47.3852 42.1385 46.4734 41.9611 45.5056C41.7838 44.5378 41.8388 43.5418 42.1217 42.5994C42.2604 42.1198 42.5156 41.6819 42.8645 41.3248C43.2135 40.9677 43.6454 40.7024 44.1217 40.5527C43.3817 41.9994 42.1017 45.2794 43.6484 48.6261Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8097 25.8203V27.6803C48.2112 27.8529 47.5924 27.9448 46.9697 27.9536L46.9297 26.207C47.5755 26.2009 48.2139 26.0696 48.8097 25.8203Z",
    fill: "#808080"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7685 18.873C47.7685 19.6197 47.7685 20.3997 47.7152 21.213C47.7152 21.553 47.7152 21.8797 47.6618 22.2597C47.36 27.8368 46.3382 33.3514 44.6218 38.6664C42.2752 45.473 38.5152 50.913 32.8885 50.913C22.8218 50.913 18.6752 33.4664 18.0818 21.7397C18.0818 21.5664 18.0818 21.3864 18.0818 21.213C18.0818 20.3997 18.0352 19.6197 18.0352 18.873H47.7685Z",
    fill: "url(#paint4_linear_845_38405)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0232 38.4193V36.986H31.6898V28.246H30.8965V26.666H35.0165V36.986H35.6832V38.4193H31.0232Z",
    fill: "#FF9D09"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0165 36.986V26.666H30.8965V27.2127H34.5165V37.5393H35.1832V38.4193H35.6632V36.986H35.0165Z",
    fill: "#767676"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5352 27.2407L35.0152 26.7207V36.9407L34.5352 37.534V27.2407Z",
    fill: "#767676"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6831 36.9863V38.4197H35.2031V37.5997L35.6831 36.9863Z",
    fill: "#767676"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6236 38.6664C42.9303 43.573 40.517 47.7797 37.1836 49.7397C35.8961 50.5095 34.4237 50.915 32.9236 50.913C22.857 50.913 18.7103 33.4664 18.117 21.7397C18.117 21.5664 18.117 21.3864 18.117 21.213C18.117 20.3997 18.0703 19.6197 18.0703 18.873H27.417L26.9703 20.5664C26.9703 20.5664 28.357 53.8264 44.6236 38.6664Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4627 49.5464C25.7693 45.253 21.696 26.7397 20.516 18.873H18.916C18.916 19.6197 18.916 20.3997 18.9627 21.213C18.9627 21.3864 18.9627 21.5664 18.9627 21.7464C19.5493 33.293 23.5827 50.413 33.3293 50.8997L37.4627 49.5464Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7698 18.873C47.7698 19.6197 47.7698 20.3997 47.7164 21.213C47.7164 21.553 47.7164 21.8797 47.6631 22.2597C41.0836 21.5387 34.4686 21.1892 27.8498 21.213C21.6631 21.213 19.0831 21.473 18.0564 21.7397C18.0564 21.5664 18.0564 21.3864 18.0564 21.213C18.0564 20.3997 18.0098 19.6197 18.0098 18.873H47.7698Z",
    fill: "#808080"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6292 18L49.3826 18.8267L48.9359 20.3333H16.8426L16.1426 18H49.6292Z",
    fill: "url(#paint5_linear_845_38405)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8973 51.927L37.624 52.1604C37.2429 52.4921 36.8885 52.8532 36.564 53.2404C36.3235 53.4943 36.1655 53.815 36.1106 54.1604C36.1166 55.1205 35.9864 56.0767 35.724 57.0004C35.6352 57.3168 35.5238 57.6265 35.3906 57.927L35.3373 58.0604C35.2773 58.1737 35.224 58.2937 35.164 58.4004C34.584 59.487 33.7773 60.1604 32.8906 60.1604C32.3941 60.1422 31.9208 59.9458 31.5573 59.607C31.0831 59.1771 30.7078 58.6494 30.4573 58.0604C29.9252 56.8301 29.6615 55.5006 29.684 54.1604C29.684 53.367 27.8906 51.927 27.8906 51.927V51.887L28.5573 49.707H37.184L37.5306 50.8137L37.784 51.6137L37.8706 51.887L37.8973 51.927Z",
    fill: "#FFBD26"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.884 51.887H27.8906L28.5773 49.707H37.1973L37.544 50.8137L37.7973 51.6137L37.884 51.887Z",
    fill: "url(#paint6_linear_845_38405)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5417 59.607C30.435 58.6604 29.6683 56.5804 29.6683 54.1604C29.6683 53.367 27.875 51.927 27.875 51.927L28.575 49.707H37.1817C37.1817 49.707 28.4417 50.1004 30.415 52.1737C30.5483 52.527 31.9483 52.6137 31.9483 52.6137C31.9483 52.6137 30.615 57.6804 32.3817 58.0604C33.235 58.2337 32.515 58.9337 31.5417 59.607Z",
    fill: "#808080"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9229 60.1605H29.8496L30.4429 58.0605H35.3363L35.4829 58.6005L35.8496 59.8805L35.9229 60.1605Z",
    fill: "url(#paint7_linear_845_38405)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3226 75.0935H28.4492L29.8492 60.1602H35.9226L35.9492 60.4468L37.3226 75.0935Z",
    fill: "#FFBD26"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8957 51.9258L37.6224 52.1592C35.7757 52.1592 33.1891 52.0458 32.2891 52.0325C32.7959 52.0126 33.3012 51.9637 33.8024 51.8858C35.0844 51.6558 36.3397 51.2961 37.5491 50.8125L37.8024 51.6125L37.8891 51.8858L37.8957 51.9258Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9496 60.4475L31.8496 60.1609L35.8496 59.8809L35.9429 60.1609L35.9496 60.4475Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6301 18L49.3834 18.8267L24.6367 18H49.6301Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3963 58.0605L31.8829 60.1605H29.8496L30.4429 58.0605H32.3963Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8826 60.1602L31.1425 75.0935H30.9892H28.4492L29.8492 60.1602H31.8826Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6891 20.3333H16.8424L16.1758 18H22.1224C21.4491 18.4267 19.5891 20.1267 30.6891 20.3333Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8492 20.3333H16.8426L16.1426 18H17.8226L18.8492 20.3333Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M28.17 36.8526C28.17 36.8526 25.0233 29.5926 25.6367 22.5859H22.75C22.75 22.5859 23.4833 32.1326 28.17 36.8526Z",
    fill: "url(#paint8_linear_845_38405)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M38.2031 40.4393C38.2123 40.3662 38.2123 40.2923 38.2031 40.2193C38.3298 38.1593 38.2031 22.5859 38.2031 22.5859H46.4565C46.4565 22.5859 46.6031 39.1259 38.2031 40.4393Z",
    fill: "url(#paint9_linear_845_38405)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9102 40.7009C38.0368 38.6476 37.9102 23.0742 37.9102 23.0742H41.1835C41.1835 26.7009 40.8435 36.3742 37.9102 40.7009Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1106 18H32.8906V20.3333H39.1106V18Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2564 18H40.623V20.3333H42.2564V18Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6689 20.0391H54.6289V21.7924H56.6689V20.0391Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6689 30.9258V34.0658C56.0414 34.8963 55.3599 35.6847 54.6289 36.4258V33.8191C55.3844 32.9102 56.0666 31.9427 56.6689 30.9258Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7707 20.0391H57.7773V21.7924H58.7707V20.0391Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7707 26.2676V30.7476C58.4573 31.3409 58.104 31.9076 57.7773 32.4676V28.8142C58.1606 27.9866 58.4923 27.1361 58.7707 26.2676Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0507 20.0391H7.77734V21.7924H10.0507V20.0391Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0507 32.0866V34.9933C9.20548 33.9797 8.44514 32.8983 7.77734 31.76V27.8066C8.38237 29.3093 9.14438 30.744 10.0507 32.0866Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3568 20.0391H11.2168V21.7924H12.3568V20.0391Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3568 34.941V37.381C11.9635 37.0276 11.5835 36.661 11.2168 36.2876V33.6543C11.5768 34.101 11.9568 34.5343 12.3568 34.941Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6368 49.0805C45.4678 49.1144 45.2959 49.1322 45.1235 49.1338C44.8627 49.1346 44.6036 49.0918 44.3568 49.0071C44.1946 48.1745 44.1098 47.3287 44.1035 46.4805C44.1993 46.6698 44.318 46.8467 44.4568 47.0071L45.6368 49.0805Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5561 75.0933H33.8828L34.5295 63.4199L36.5561 75.0933Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1301 75.0933H32.7168V63.4199L33.1301 75.0933Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3438 53.7069C34.1704 54.1336 35.8704 55.9869 34.2104 57.8802C33.9261 57.9603 33.6365 58.0205 33.3438 58.0602C33.9742 58.0422 34.6014 58.1581 35.1837 58.4002C35.2988 58.4525 35.4064 58.5198 35.5037 58.6002L35.3571 58.0602L35.4104 57.9269C35.4104 57.8669 35.4637 57.8002 35.4837 57.7402C35.5189 57.6664 35.55 57.5907 35.5771 57.5136C35.6371 57.3536 35.6904 57.1802 35.7437 57.0002C36.0062 56.0766 36.1364 55.1204 36.1304 54.1602C36.1853 53.8149 36.3433 53.4941 36.5837 53.2402C35.5334 53.5582 34.4411 53.7155 33.3438 53.7069Z",
    fill: "#808080"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_845_38405",
    x1: 22.0629,
    y1: 33.6791,
    x2: -4.63706,
    y2: 36.6057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_845_38405",
    x1: 17.7964,
    y1: 35.5324,
    x2: 1.24974,
    y2: 10.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFA11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_845_38405",
    x1: 41.1635,
    y1: 34.7409,
    x2: 60.9768,
    y2: 34.7409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_845_38405",
    x1: 41.855,
    y1: 34.5857,
    x2: 61.6684,
    y2: 34.5857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFA11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_845_38405",
    x1: 18.0085,
    y1: 34.893,
    x2: 47.7685,
    y2: 34.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFBD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_845_38405",
    x1: 16.1426,
    y1: 19.1667,
    x2: 49.6359,
    y2: 19.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFBD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_845_38405",
    x1: 27.8906,
    y1: 50.7937,
    x2: 37.884,
    y2: 50.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFBD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_845_38405",
    x1: 30.0896,
    y1: 59.1472,
    x2: 39.0763,
    y2: 59.0339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFBD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_845_38405",
    x1: 22.75,
    y1: 29.7193,
    x2: 28.17,
    y2: 29.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_845_38405",
    x1: 38.2031,
    y1: 31.5126,
    x2: 46.4565,
    y2: 31.5126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuara1);
export default __webpack_public_path__ + "static/media/juara-1.1b54a310a6b43a2f4a3e135071975cde.svg";
export { ForwardRef as ReactComponent };